import React from "react";
import Sidebar from "../../../layouts/Main/components/Sidebar/Sidebar";
import foldersNavData from "./foldersNavData";

/**
 * This is a domain specific implementation of the sidebar component (which it wraps).
 * It contains the folder page specific values for the sidebar comp rendered there.
 * That component should remain generic and be wrapped with page specific implementations
 * as seen here.
 */
export default function FoldersSidebar(props) {
	return <Sidebar navData={foldersNavData} {...props} />;
}
